import app, { csl, u_, vuwer } from "@@assets/scripts/common";
import formImporter from "@@assets/form/importer";


// **** process ****
async function setForm() {
	await formImporter();
	
	/**********************
	*  setting component  *
	**********************/
	vuwer
	.add("fm", {
		vuwType: "jbForm",
		selector: "#auth_fm",
		app,
		ACTION_URL: `${app.config.apipath}/downloads.php`,
		inputIdPrefix: "auth",
		confirmSheetName: false,	// 確認シートなし
		finishSheetName: false,	// 完了シートなし
		autoInit: false,
		REST: false,
		
		// フォームの値が更新された後のコールバック
		onUpdate(item, config) {},
		
		// jsValidate実行時のコールバック
		// objErrorの中身は{count: エラー数, $elm: 最初のエラーの$オブジェクト（countが0の場合はnull）}
		onValidate($actvSheet, objError, config) {},
		
		// 確認シートへ値がコピーされる際のコールバック
		onCopyToConfirmSheet($cloneSheet, config) {},
		
		// submit成功コールバック
		onSubmitSuccess(config, res) {
			csl.log.red("success", res);
			if( u_.isObject(res) && Array.isArray(res.data) ) {
				vuwer.downloads = res.data;
				vuwer.setState({});
			}
		},
		
		async onReadyFirst($self) {
			if(!$self) {
				return false;
			}
			
			const res = await this._promise;
			if( u_.isObject(res) && Array.isArray(res.data) ) {
				vuwer.downloads = res.data;
				
			} else {
				await this.initForm();
			}
		}
	}, function() {
		// 設定データのロード
		this._promise = this.loadConfig();
		
		// appから直接アクセス可能にする
		app.fm = this;
	});
	
	return vuwer.get("fm");
}

export default setForm;
